/**
 * It's a React component that renders a list of items that when clicked, will update the state of the
 * parent component
 * @param {Props} props - {
 * @returns The return is a React component.
 */
import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import FieldTypes from "../../Types/FieldTypes"
import "./DynamicFormEditorHistory.css"

interface Props {
    history: Array<Array<Array<FieldTypes>>>
    originalTemplate: Array<Array<FieldTypes>>
    manageParentState: Function
    hints: boolean
}

function DynamicFormEditorHistory(props: Props) {

    const history = props.history

    const DynamicFormEditorHistoryToolTip = (text: string, overrideHints?: boolean) => (
        <Tooltip id={`dynamic-form-tool-tip-hide-${!props.hints && !overrideHints}`}>
            {text}
        </Tooltip>
    )

    return (
        <div className="DynamicFormEditorHistory">
            <span className="material-icons">history</span>
            <div className="DynamicFormEditorHistoryItems">
                <OverlayTrigger placement="top" overlay={DynamicFormEditorHistoryToolTip("Switch back to the original template")}>
                    <div className="DynamicFormEditorHistoryItemOriginal">
                        <div className="DynamicFormEditorHistoryItemOriginalInner"
                            onClick={() => props.manageParentState([{ key: "template", value: props.originalTemplate }])}>
                            Original
                        </div>
                    </div>
                </OverlayTrigger>
                {history.map(((item, i: number) =>
                    <div className="DynamicFormEditorHistoryItem" key={`dynamic-form-editor-history-item-${i}`}>
                        <div className="DynamicFormEditorHistoryItemInner"
                            onClick={() => props.manageParentState([{ key: "template", value: item }])}>
                            {i + 1}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default DynamicFormEditorHistory